'use client';

import { useTranslations } from 'next-intl';
import React from 'react';
import ProfileDetailsContainer from '../ProfileDetailsContainer';
import PlayerAccount from './PlayerAccount';
import { PlayerProfile } from '@wwe-portal/entities/player.type';
import LastRefresh from '../LastRefresh';
import ProfileDetailsBadge from './ProfileDetailsBadge';
import ProfileDetailsCard from './ProfileDetailsCard';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { usePlayerDetails } from './usePlayerDetails';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

function PlayerDetails({
  playerProfile,
}: Readonly<{ playerProfile: PlayerProfile }>) {
  const t = useTranslations();
  const details = usePlayerDetails(t, playerProfile);
  const { isMobile, isHydrated } = useResponsive();
  const showMobile = isHydrated && isMobile;

  return (
    <div className="player-details profile-details">
      <ProfileDetailsContainer>
        {!showMobile && (
          <LastRefresh lastActivityDate={playerProfile?.snapshot_date} />
        )}
        <div className="flex flex-col justify-between md:flex-row">
          <PlayerAccount
            userId={playerProfile?.user_id}
            playerName={playerProfile?.player_name}
            factionName={details.factionName}
            rosterTalent={details.factionTotalRosterTalent}
            lastActivityDate={playerProfile?.last_activity_date}
            avatarUrl={playerProfile?.imageUrl}
            avatarFrameUrl={playerProfile?.profileFrame}
            avatarRarity={details.avatarRarity}
          />
          {showMobile && <hr className="hr-profile my-[40px]" />}
          <div className="flex flex-col items-center md:flex-row">
            <ProfileDetailsBadge
              title={t('league')}
              bgImg="/assets/images/player/profile-badge_1.webp"
              data={details.leagueLevel}
            />
            <div className="profile-details-item ml-0 mt-[30px] flex w-full overflow-hidden px-5 md:ml-auto md:mt-0 md:flex-wrap md:px-0">
              <div className="flex w-full flex-col items-center">
                <ProfileDetailsCard
                  icon={
                    <IcoMoonIcon
                      iconName="shild"
                      className="text-green700 size-6"
                    />
                  }
                  count={details.totalRosterTalent}
                  title={t('roster_talent')}
                />
                {showMobile && <hr />}
                <ProfileDetailsCard
                  icon={
                    <IcoMoonIcon
                      iconName="user-group-fill"
                      className="text-green700 size-6"
                    />
                  }
                  count={details.rosterSize}
                  title={t('roster_size')}
                />
              </div>
            </div>
          </div>
        </div>
        {showMobile && (
          <LastRefresh lastActivityDate={playerProfile?.snapshot_date} />
        )}
      </ProfileDetailsContainer>
    </div>
  );
}

export default PlayerDetails;
